/**
 * Client-side mirror of backend/src/game/character/config/character-tuning.ts's
 * display-relevant constants — same hand-synced convention as
 * config/economy-tuning.ts. Used only to preview costs in the UI before a
 * request; the server recomputes and is authoritative on every actual transaction.
 */
export const CHARACTER = {
  LEVEL_CAP: 25,
  XP_PER_LEVEL: 200,
  RESPEC_COST_WAX: 200,
} as const;

// SLOT_COST_EMBER deliberately does not live here any more. It is the one
// price a player is shown immediately before pressing a button that spends
// it, so the UI reads it from `GET /characters/slots` instead of mirroring a
// constant that can go stale against the server.
